import { takeLatest, put, call } from 'redux-saga/effects';

import { getLiveOffersList } from '../actions/getLiveOffersList';
import { fetchLiveOffers, fetchLiveOffersSuccess, fetchLiveOffersFailure } from '../slices/liveOffersListSlice';

function* getLiveOffers(action:any):Generator<any, void, string> {
  try {
    const { VorgMpnId } = action.payload;
    const liveOffers:any = yield call(getLiveOffersList, VorgMpnId);
    yield put(fetchLiveOffersSuccess({liveOfferDetails:liveOffers}));
  } catch (error:any) {
    yield put(fetchLiveOffersFailure(error.message));
  }
}

function* offerTypesSaga() {
  yield takeLatest(fetchLiveOffers.type, getLiveOffers);
}

export default offerTypesSaga;